"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getFunctorComposition(F, G) {
  return {
    map: function map(fa, f) {
      return F.map(fa, function (ga) {
        return G.map(ga, f);
      });
    }
  };
}

exports.getFunctorComposition = getFunctorComposition;